import { useState } from 'react';
import { toggleModal } from '../../Store/layoutSlice';
import { useAppDispatch, useAppSelector } from '../../Store/store';
import { clearSecretBag, isRlbSelector, secretBagSelector, setIsRlb } from '../../Store/paramsBagSlice';

export const useKeyAndSecretPanel = () => {
  const secretBag = useAppSelector(secretBagSelector);
  const isRlb = useAppSelector(isRlbSelector)
  const [activeButton, setActiveButton] = useState('');
  const dispatch = useAppDispatch();

  const onClose = () => {
    dispatch(toggleModal());
    dispatch(clearSecretBag());
    dispatch(setIsRlb(false));
  };

  const copyToClipBoard = async (key) => {
    await navigator.clipboard.writeText(secretBag[key]);
    setActiveButton(() => key);
  };

  return { secrets: secretBag, activeButton, onClose, copyToClipBoard, isRlb };
};
